import { PillButton } from "@flash-tecnologia/hros-web-ui-v2";
import { Box } from "src/components/core-components/atoms/Box/box";
import { EllipsisTypography } from "src/components/core-components/atoms/EllipsisTypography/ellipsis-typography";
import { MemberRow } from "./added-company.styles";

export const AddedCompany = ({
  registrationNumber,
  companyName,
  onDeleteClick,
  onEditClick,
}: {
  registrationNumber: string;
  companyName: string;
  onDeleteClick?: () => void;
  onEditClick?: () => void;
}) => {
  return (
    <MemberRow>
      <Box gap="xs5" flexDirection="column" flex={1} $minWidth={0}>
        <EllipsisTypography variant="caption" color={"neutral.40"} weight={700}>
          {companyName}
        </EllipsisTypography>
        <EllipsisTypography variant="caption" color={"neutral.40"} weight={400}>
          {registrationNumber}
        </EllipsisTypography>
      </Box>
      {onDeleteClick && (
        <div>
          <PillButton
            size="extra-small"
            variant="default"
            icon="IconTrash"
            onClick={onDeleteClick}
          />
        </div>
      )}
      {onEditClick && (
        <div>
          <PillButton
            size="extra-small"
            variant="default"
            icon="IconPencil"
            onClick={onEditClick}
          />
        </div>
      )}
    </MemberRow>
  );
};
